/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sendEmailDialog/richTextInput/richTextInput"/>
import * as React from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import { TextStyleKit } from "@tiptap/extension-text-style";
import StarterKit from "@tiptap/starter-kit";
import { TokenCssVariables } from "@medius/ui-controls";
import { MenuBar } from "./menuBar";

const extensions = [TextStyleKit, StarterKit];
export interface RichTextInputProps {
  value: string;
  inputTestId?: string;
  onChange: (value: string) => void;
}

export const RichTextInput = (props: RichTextInputProps) => {
  const { value, inputTestId, onChange } = props;
  const editor = useEditor({
    extensions,
    content: value,
    onUpdate: (eventProps) => onChange(eventProps.editor.getHTML()),
  });
  return (
    <div style={{border: `1px solid ${TokenCssVariables.ColorGrey30}`, height: "280px", width: "100%", overflowY: "auto", padding: "4px"}}>
      <MenuBar editor={editor} />
      <div style={{padding: "8px"}}>
        <EditorContent data-testid={inputTestId} editor={editor} />
      </div>
    </div>
  );
};
